export {
  defineLocale,
  getSetGlobalLocale,
  listLocales
} from './locale/locales.service';



// WEBPACK FOOTER //
// ../../.tmp/bs-moment/index.ts